var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    color: "#363A3A",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_134_221771)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.333 12H11.9997M7.99967 12H8.66634M4.66634 12H5.33301M1.33301 13.3333C1.33301 13.687 1.47348 14.0261 1.72353 14.2762C1.97358 14.5262 2.31272 14.6667 2.66634 14.6667H13.333C13.6866 14.6667 14.0258 14.5262 14.2758 14.2762C14.5259 14.0261 14.6663 13.687 14.6663 13.3333V5.33334L9.99967 8.66668V5.33334L5.33301 8.66668V2.66668C5.33301 2.31305 5.19253 1.97392 4.94248 1.72387C4.69244 1.47382 4.3533 1.33334 3.99967 1.33334H2.66634C2.31272 1.33334 1.97358 1.47382 1.72353 1.72387C1.47348 1.97392 1.33301 2.31305 1.33301 2.66668V13.3333Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_134_221771"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactory);
export default __webpack_public_path__ + "static/media/factory.e1a4c97a7e82a18871abbe1e6d5e7cb3.svg";
export { ForwardRef as ReactComponent };